enum ServiceIncreaseComputeType {
  NONE = 'NONE',
  ANNUAL_RENT = 'ANNUAL_RENT',
}

export default ServiceIncreaseComputeType
